/* eslint-disable */
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

// Registering all necessary elements for a Line/Area chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const R2RLineChart = ({
  labels = [],
  datasets = [],
  Heading = '', // Added a default for clarity
  height = '300px',
  title = '',
  showDataLabels = false, 
  showLegend = true,     
}) => {

  // Map the datasets to configure them for an area chart
  const chartData = {
    labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      type: 'line', 
      pointHitRadius: 15,       
      tension: 0.4,       
      pointRadius: 2,     
      fill: 'origin',     
      borderColor: '#ff9800', 
      backgroundColor: 'rgba(255, 152, 0, 0.3)',
      borderWidth: 3,  
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: !!title,
        text: title,
      },
      legend: {
        display: showLegend,
      },
      tooltip: {
        enabled: true,
        mode: 'index',
        intersect: false,
        callbacks: {
          labelPointStyle: function(context) {
            return {
              pointStyle: 'circle',
              rotation: 0
            };
          }
        }
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        display: true, 
        grid: {
          display: false,
        },
        ticks: { // <--- X-AXIS TICK STYLING
          color: '#5c5959ff',
          font: {
            // weight: 'bold',
            size: '8px'
          }
        }
      },
      y: {
        display: true,
        beginAtZero: true, 
        grid: {
          display: true, 
        },
        ticks: { // <--- Y-AXIS TICK STYLING
          color: '#5c5959ff',
          font: {
            // weight: 'bold',
            size: '8px'
          }
        }
      },
    },
  };

  return (
    <div style={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fff' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
        <div>
          {/* <h4 style={{ margin: '0', fontSize: '18px', fontWeight: 'bold', color: '#000000' }}>{Heading}</h4> */}
          <h4 style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#1e3a8a',borderBottom:'2px solid #3b82f6', paddingBottom:'4px', display:'inline-block' }}>{Heading}</h4>
        </div>
      </div>

      <div style={{ width: '100%', height: height }}>
        <Line data={chartData} options={options} /> 
      </div>
    </div>
  );
};

export default R2RLineChart;